import { convertOpeningTime } from './'

export const sanitizeOpeningTimes = (input, options) => {
  const dash = options && options.longDash ? String.fromCodePoint(8211) : '–'
  const spacing = options && options.lineBreak ? '\n' : ' '

  let aggregated = input.reduce((aggr, currentItem) => {
    let prev = aggr[aggr.length - 1]
    const sameOpenFrom = currentItem.open_from === prev?.open_from
    const sameOpenUntil = currentItem.open_until === prev?.open_until
    if (!prev) {
      aggr.push(currentItem)
    } else if (sameOpenFrom && sameOpenUntil && prev) {
      prev.untilWeekday = currentItem.weekday
    } else {
      aggr.push(currentItem)
    }
    return aggr
  }, [])

  return aggregated.map(obj => {
    let abbreviatedWeekday = obj.weekday.substr(0, 2)

    if (obj.untilWeekday) {
      abbreviatedWeekday += `-${obj.untilWeekday.substr(0, 2)}`
    }

    const openFrom =
      obj.open_from && options && options.removeLatinCharactersFromTimes
        ? convertOpeningTime(obj.open_from.replace(/[a-z]+/i, '').trim())
        : convertOpeningTime(obj.open_from)
    const openUntil =
      obj.open_until && options && options.removeLatinCharactersFromTimes
        ? convertOpeningTime(obj.open_until.replace(/[a-z]+/i, '').trim())
        : convertOpeningTime(obj.open_until)

    return `${abbreviatedWeekday}${spacing}${openFrom}${dash}${openUntil}`
  })
}

export const sanitizeOpeningTimesRange = input => {
  let aggregated = input.reduce((aggr, currentItem) => {
    let prev = aggr[aggr.length - 1]
    const sameOpenFrom = currentItem.open_from === prev?.open_from
    const sameOpenUntil = currentItem.open_until === prev?.open_until
    if (!prev) {
      currentItem.openingDays = [currentItem.weekday]
      aggr.push(currentItem)
    } else if (sameOpenFrom && sameOpenUntil && prev) {
      prev.openingDays.push(currentItem.weekday)
    } else {
      currentItem.openingDays = []
      aggr.push(currentItem)
    }
    return aggr
  }, [])

  return aggregated.map(obj => ({
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: obj.openingDays,
    opens: obj.open_from,
    closes: obj.open_until
  }))
}
